<!-- Header (fixed) -->
<div class="dialog-container" [class.insurance-dialog]="selected_dialog_mode === 'insurance' && dialogMode !== 'view'">
  <div class="dialog-header">
    <div class="user-edit-icon" [ngSwitch]="selected_dialog_mode">
      <svg *ngSwitchCase="'allergy'" class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3"/><line x1="12" y1="9" x2="12" y2="4"/><circle cx="12" cy="3.5" r="1.2"/><line x1="14.6" y1="10.4" x2="18.6" y2="7.2"/><circle cx="19.3" cy="6.7" r="1.2"/><line x1="14.6" y1="13.6" x2="18.6" y2="16.8"/><circle cx="19.3" cy="17.3" r="1.2"/><line x1="12" y1="15" x2="12" y2="20"/><circle cx="12" cy="20.5" r="1.2"/><line x1="9.4" y1="13.6" x2="5.4" y2="16.8"/><circle cx="4.7" cy="17.3" r="1.2"/><line x1="9.4" y1="10.4" x2="5.4" y2="7.2"/><circle cx="4.7" cy="6.7" r="1.2"/></svg>
      <img *ngSwitchCase="'medicalcondition'" src="assets/images/health/icons/med-rep.png" class="add-icon" style="width:30px; height: 30px;" alt="" />
      <svg *ngSwitchCase="'familyhistory'" class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2 21a7 7 0 0 1 14 0M17 4.5a3.5 3.5 0 0 1 0 7M22 21a7 7 0 0 0-4-6.3"/></svg>
      <svg *ngSwitchCase="'insurance'" aria-hidden="true" class="dash-ico dash-ico--ins" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
      <svg *ngSwitchCase="'immunization'" class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M18 2l4 4M17 7l3-3M19 9l-8.7 8.7a2 2 0 0 1-2.8 0L6.3 16.5a2 2 0 0 1 0-2.8L15 5M9 11l4 4M5 19l-3 3M14 4l6 6"/></svg>
    </div>

    <div class="header-text">
      <h2 class="addmed">
        {{ dialogTitle }}
      </h2>
    </div>

    <button type="button" class="close-button" (click)="onCancel()" aria-label="Close">
      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
        <path fill="currentColor"
          d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      </svg>
    </button>
  </div>

  <!-- Body (the ONLY scrolling area, scrollbar hidden) -->
  <div class="dialog-content">

    <!-- Insurance only: compact upload row + selected documents (one horizontal row, scrolls sideways after 3).
         The picked files are uploaded with the Health category document API when the form is saved
         (subtag Health-<insurance id>, user tag Insurance). Edit mode also lists the documents already stored. -->
    <div class="ins-upload" *ngIf="selected_dialog_mode === 'insurance' && dialogMode !== 'view'">
      <input #insFile type="file" hidden multiple
             (change)="onInsuranceFilesSelected($event)" />
      <button type="button" class="ins-upload-row" (click)="insFile.click()">
        <mat-icon class="ins-upload-icon" aria-hidden="true">cloud_upload</mat-icon>
        <span class="ins-upload-text">
          <span class="ins-upload-title">Upload insurance documents</span>
          <span class="ins-upload-sub">(Policy / ID / Card)</span>
        </span>
        <span class="ins-upload-action">Upload</span>
      </button>

      <div class="ins-docs" *ngIf="insuranceDocs.length">
        <div class="ins-docs-head">
          <span class="ins-docs-title">Uploaded Documents ({{ insuranceDocs.length }})</span>
          <button type="button" class="ins-docs-clear" (click)="clearInsuranceDocs()">Clear all</button>
        </div>
        <div class="ins-docs-list ins-docs-list--actions">
          <div class="ins-doc" *ngFor="let doc of insuranceDocs; let i = index"
               [class.ins-doc--editing]="editingInsDocIndex === i"
               [attr.title]="editingInsDocIndex === i ? null : insuranceDocDisplayName(doc)">
            <mat-icon class="ins-doc-icon" aria-hidden="true">description</mat-icon>

            <!-- normal state: name + preview (eye), rename (pencil), remove -->
            <ng-container *ngIf="editingInsDocIndex !== i; else editInsDocName">
              <span class="ins-doc-name">{{ insuranceDocDisplayName(doc) }}</span>
              <button type="button" class="ins-doc-action" [attr.aria-label]="'Preview ' + insuranceDocDisplayName(doc)" (click)="previewInsuranceDoc(doc)">
                <mat-icon aria-hidden="true">visibility</mat-icon>
              </button>
              <button type="button" class="ins-doc-action" [attr.aria-label]="'Rename ' + insuranceDocDisplayName(doc)" (click)="startEditInsuranceDoc(i)">
                <mat-icon aria-hidden="true">edit</mat-icon>
              </button>
              <button type="button" class="ins-doc-remove" [attr.aria-label]="'Remove ' + insuranceDocDisplayName(doc)" (click)="removeInsuranceDoc(i)">
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </ng-container>

            <!-- rename state: the extension stays fixed, Enter saves, Escape cancels -->
            <ng-template #editInsDocName>
              <input #insDocInput class="ins-doc-input" type="text" [attr.maxlength]="insDocNameMax" aria-label="Document name"
                     [value]="editingInsDocName"
                     (input)="editingInsDocName = $any($event.target).value"
                     (keydown.enter)="saveEditInsuranceDoc(i); $event.preventDefault()"
                     (keydown.escape)="cancelEditInsuranceDoc(); $event.stopPropagation()" />
              <span class="ins-doc-ext" *ngIf="insuranceDocExtension(doc)">{{ insuranceDocExtension(doc) }}</span>
              <button type="button" class="ins-doc-action ins-doc-action--save" aria-label="Save name" (click)="saveEditInsuranceDoc(i)">
                <mat-icon aria-hidden="true">check</mat-icon>
              </button>
              <button type="button" class="ins-doc-action" aria-label="Cancel rename" (click)="cancelEditInsuranceDoc()">
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="ins-docs" *ngIf="insuranceSavedDocs.length">
        <div class="ins-docs-head">
          <span class="ins-docs-title">Saved Documents ({{ insuranceSavedDocs.length }})</span>
        </div>
        <div class="ins-docs-list ins-docs-list--actions">
          <div class="ins-doc" *ngFor="let doc of insuranceSavedDocs"
               [class.ins-doc--editing]="editingSavedDocId === doc.id"
               [attr.title]="editingSavedDocId === doc.id ? null : doc.name">
            <mat-icon class="ins-doc-icon" aria-hidden="true">description</mat-icon>

            <!-- normal state: name + preview (eye), rename (pencil), remove. Rename/remove are applied when the form is saved. -->
            <ng-container *ngIf="editingSavedDocId !== doc.id; else editSavedDocName">
              <span class="ins-doc-name" style="cursor: pointer" (click)="openSavedInsuranceDoc(doc)">{{ doc.name }}</span>
              <button type="button" class="ins-doc-action" [attr.aria-label]="'Preview ' + doc.name" (click)="openSavedInsuranceDoc(doc)">
                <mat-icon aria-hidden="true">visibility</mat-icon>
              </button>
              <button type="button" class="ins-doc-action" [attr.aria-label]="'Rename ' + doc.name" (click)="startEditSavedInsuranceDoc(doc)">
                <mat-icon aria-hidden="true">edit</mat-icon>
              </button>
              <button type="button" class="ins-doc-remove" [attr.aria-label]="'Remove ' + doc.name" (click)="removeSavedInsuranceDoc(doc)">
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </ng-container>

            <!-- rename state: Enter saves, Escape cancels -->
            <ng-template #editSavedDocName>
              <input #insSavedDocInput class="ins-doc-input" type="text" [attr.maxlength]="insDocNameMax" aria-label="Document name"
                     [value]="editingSavedDocName"
                     (input)="editingSavedDocName = $any($event.target).value"
                     (keydown.enter)="saveEditSavedInsuranceDoc(doc); $event.preventDefault()"
                     (keydown.escape)="cancelEditSavedInsuranceDoc(); $event.stopPropagation()" />
              <button type="button" class="ins-doc-action ins-doc-action--save" aria-label="Save name" (click)="saveEditSavedInsuranceDoc(doc)">
                <mat-icon aria-hidden="true">check</mat-icon>
              </button>
              <button type="button" class="ins-doc-action" aria-label="Cancel rename" (click)="cancelEditSavedInsuranceDoc()">
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- View Details: read-only rows built from the selected record -->
    <div class="view-details" *ngIf="dialogMode === 'view'">
      <dl class="view-grid">
        <div class="view-item" *ngFor="let f of viewFields" [class.view-item--full]="f.full">
          <dt class="view-label">{{ f.label }}</dt>
          <ng-container *ngIf="f.docs; else plainValue">
            <dd class="view-value view-value--empty" *ngIf="insuranceDocsLoading">Loading documents…</dd>
            <dd class="view-docs" *ngIf="!insuranceDocsLoading && insuranceSavedDocs.length">
              <button type="button" class="view-doc" *ngFor="let doc of insuranceSavedDocs"
                      [attr.title]="doc.name" [attr.aria-label]="'Open ' + doc.name" (click)="openSavedInsuranceDoc(doc)">
                <mat-icon class="view-doc-icon" aria-hidden="true">description</mat-icon>
                <span class="view-doc-name">{{ doc.name }}</span>
                <mat-icon class="view-doc-open" aria-hidden="true">visibility</mat-icon>
              </button>
            </dd>
            <dd class="view-value view-value--empty" *ngIf="!insuranceDocsLoading && !insuranceSavedDocs.length">—</dd>
          </ng-container>
          <ng-template #plainValue>
            <dd class="view-value" [class.view-value--empty]="f.empty">{{ f.value }}</dd>
          </ng-template>
        </div>
      </dl>
    </div>

    <form *ngIf="dialogMode !== 'view'" [formGroup]="myForm" class="dialog-form">

      <!-- ========== MEDICAL CONDITION ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'medicalcondition'">
        <div class="form-row">
          <div class="field">
            <label class="field-label" for="mcName">Condition Name <span class="req">*</span></label>
            <div class="combo">
              <input id="mcName" class="control select combo-input" type="text" formControlName="conditionName"
                autocomplete="off" placeholder="e.g., Hypertension"
                role="combobox" aria-autocomplete="list" aria-haspopup="listbox"
                [attr.aria-expanded]="openMulti === 'conditionName'"
                (focus)="openCombo('conditionName')"
                (click)="$event.stopPropagation(); openCombo('conditionName')"
                (input)="openCombo('conditionName'); activeIndex = -1"
                (keydown)="onComboKey($event)" />
              <div class="multi-panel combo-panel" role="listbox"
                *ngIf="openMulti === 'conditionName'"
                (click)="$event.stopPropagation()">
                <button type="button" class="combo-option" role="option"
                  *ngFor="let c of filteredConditions | slice:0:100; let i = index"
                  [class.active]="i === activeIndex"
                  (mousedown)="$event.preventDefault()"
                  (click)="pickCondition(c.title)">{{ c.title }}</button>
                <button type="button" class="combo-option combo-option--other" role="option"
                  [class.active]="activeIndex === othersIndex"
                  (mousedown)="$event.preventDefault()"
                  (click)="pickCondition('Others')">Others</button>
              </div>
            </div>
            <span class="error-text" *ngIf="getError('conditionName') as err">{{ err }}</span>
            <div class="other-wrap" *ngIf="hasOther('conditionName')">
              <input id="conditionOther" class="control other-input" type="text" formControlName="conditionOther"
                placeholder="Specify condition name" aria-label="Other condition name" />
              <span class="error-text" *ngIf="getError('conditionOther') as err">{{ err }}</span>
            </div>
          </div>

          <div class="field">
            <label class="field-label" for="mcYear">Year of Diagnosis <span class="req">*</span></label>
            <select id="mcYear" class="control select" formControlName="yearOfDiagnosis">
              <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
            </select>
            <span class="error-text" *ngIf="getError('yearOfDiagnosis') as err">{{ err }}</span>
          </div>
        </div>

        <div class="form-row form-row--full">
          <div class="field">
            <label class="field-label" for="mcComment">Add More Details (Optional) (Optional)</label>
            <textarea id="mcComment" class="control textarea" rows="2" formControlName="comment"></textarea>
          </div>
        </div>
      </ng-container>

      <!-- ========== ALLERGY ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'allergy'">
        <div class="form-row">
          <div class="field">
            <label class="field-label" for="alTo">Allergic To <span class="req">*</span></label>
            <input id="alTo" class="control" type="text" formControlName="allergicTo" placeholder="e.g., Peanuts" />
            <span class="error-text" *ngIf="getError('allergicTo') as err">{{ err }}</span>
          </div>

          <div class="field">
            <label class="field-label" for="alSeverity">Severity <span class="req">*</span></label>
            <select id="alSeverity" class="control select" formControlName="severity"
              [compareWith]="sameValue" [class.is-placeholder]="!myForm.get('severity')?.value">
              <option [ngValue]="''" disabled>Select severity</option>
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
            <span class="error-text" *ngIf="getError('severity') as err">{{ err }}</span>
          </div>
        </div>

        <div class="form-row form-row--full">
          <div class="field">
            <span class="field-label" id="alReactionsLabel">Allergic Reactions <span class="req">*</span></span>
            <div class="multi" [class.open]="openMulti === 'allergicReaction'">
              <button type="button" class="control select multi-trigger"
                aria-haspopup="listbox" aria-labelledby="alReactionsLabel"
                [attr.aria-expanded]="openMulti === 'allergicReaction'"
                [class.is-placeholder]="!selectedValues('allergicReaction').length"
                (click)="toggleOpen('allergicReaction', $event)">{{ selectedText('allergicReaction', 'Select reactions') }}</button>
              <div class="multi-panel" role="listbox" aria-multiselectable="true"
                *ngIf="openMulti === 'allergicReaction'" (click)="$event.stopPropagation()">
                <label class="multi-option" *ngFor="let reaction of allergReactions">
                  <input type="checkbox"
                    [checked]="isChecked('allergicReaction', reaction.title)"
                    (change)="toggleMulti('allergicReaction', reaction.title, $any($event.target).checked)" />
                  <span>{{ reaction.title }}</span>
                </label>
                <label class="multi-option">
                  <input type="checkbox"
                    [checked]="isChecked('allergicReaction', 'Others')"
                    (change)="toggleMulti('allergicReaction', 'Others', $any($event.target).checked)" />
                  <span>Others</span>
                </label>
              </div>
            </div>
            <span class="error-text" *ngIf="getError('allergicReaction') as err">{{ err }}</span>
            <div class="other-wrap" *ngIf="hasOther('allergicReaction')">
              <input id="reactionOther" class="control other-input" type="text" formControlName="reactionOther"
                placeholder="Specify other reactions (separate with commas)" aria-label="Other allergic reactions" />
              <span class="error-text" *ngIf="getError('reactionOther') as err">{{ err }}</span>
            </div>
          </div>
        </div>

        <div class="form-row form-row--full">
          <div class="field">
            <label class="field-label" for="alComment">Add More Details (Optional)</label>
            <textarea id="alComment" class="control textarea" rows="2" formControlName="comment"></textarea>
          </div>
        </div>
      </ng-container>

      <!-- ========== FAMILY HISTORY ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'familyhistory'">
        <div class="form-row form-row--full">
          <div class="field">
            <label class="field-label" for="fhName">Condition Name <span class="req">*</span></label>
            <div class="combo">
              <input id="fhName" class="control select combo-input" type="text" formControlName="conditionName"
                autocomplete="off" placeholder="e.g., Hypertension"
                role="combobox" aria-autocomplete="list" aria-haspopup="listbox"
                [attr.aria-expanded]="openMulti === 'conditionName'"
                (focus)="openCombo('conditionName')"
                (click)="$event.stopPropagation(); openCombo('conditionName')"
                (input)="openCombo('conditionName'); activeIndex = -1"
                (keydown)="onComboKey($event)" />
              <div class="multi-panel combo-panel" role="listbox"
                *ngIf="openMulti === 'conditionName'"
                (click)="$event.stopPropagation()">
                <button type="button" class="combo-option" role="option"
                  *ngFor="let c of filteredConditions | slice:0:100; let i = index"
                  [class.active]="i === activeIndex"
                  (mousedown)="$event.preventDefault()"
                  (click)="pickCondition(c.title)">{{ c.title }}</button>
                <button type="button" class="combo-option combo-option--other" role="option"
                  [class.active]="activeIndex === othersIndex"
                  (mousedown)="$event.preventDefault()"
                  (click)="pickCondition('Others')">Others</button>
              </div>
            </div>
            <span class="error-text" *ngIf="getError('conditionName') as err">{{ err }}</span>
            <div class="other-wrap" *ngIf="hasOther('conditionName')">
              <input id="conditionOther" class="control other-input" type="text" formControlName="conditionOther"
                placeholder="Specify condition name" aria-label="Other condition name" />
              <span class="error-text" *ngIf="getError('conditionOther') as err">{{ err }}</span>
            </div>
          </div>
        </div>

        <div class="form-row form-row--full">
          <div class="field">
            <span class="field-label" id="fhRelLabel">Relationship <span class="req">*</span></span>
            <div class="multi" [class.open]="openMulti === 'relationship'">
              <button type="button" class="control select multi-trigger"
                aria-haspopup="listbox" aria-labelledby="fhRelLabel"
                [attr.aria-expanded]="openMulti === 'relationship'"
                [class.is-placeholder]="!selectedValues('relationship').length"
                (click)="toggleOpen('relationship', $event)">{{ selectedText('relationship', 'Select relationship') }}</button>
              <div class="multi-panel" role="listbox" aria-multiselectable="true"
                *ngIf="openMulti === 'relationship'" (click)="$event.stopPropagation()">
                <label class="multi-option" *ngFor="let item of fam_historty_list">
                  <input type="checkbox"
                    [checked]="isChecked('relationship', item)"
                    (change)="toggleMulti('relationship', item, $any($event.target).checked)" />
                  <span>{{ item | titlecase }}</span>
                </label>
              </div>
            </div>
            <span class="error-text" *ngIf="getError('relationship') as err">{{ err }}</span>
            <div class="other-wrap" *ngIf="hasOther('relationship')">
              <input id="relationshipOther" class="control other-input" type="text" formControlName="relationshipOther"
                placeholder="Specify relationship (separate with commas)" aria-label="Other relationship" />
              <span class="error-text" *ngIf="getError('relationshipOther') as err">{{ err }}</span>
            </div>
          </div>
        </div>

        <div class="form-row form-row--full">
          <div class="field">
            <label class="field-label" for="fhComment">Add More Details (Optional)</label>
            <textarea id="fhComment" class="control textarea" rows="2" formControlName="comment"></textarea>
          </div>
        </div>
      </ng-container>

      <!-- ========== INSURANCE ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'insurance'">
        <div class="form-row">
          <div class="field">
            <label class="field-label" for="inCompany">Insurance Company <span class="req">*</span></label>
            <input id="inCompany" class="control" type="text" formControlName="insuranceCompany" />
            <span class="error-text" *ngIf="getError('insuranceCompany') as err">{{ err }}</span>
          </div>

          <div class="field">
            <label class="field-label" for="inPolicy">Policy Number <span class="req">*</span></label>
            <input id="inPolicy" class="control" type="text" formControlName="policyNumber" />
            <span class="error-text" *ngIf="getError('policyNumber') as err">{{ err }}</span>
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <label class="field-label" for="inMember">Member ID</label>
            <input id="inMember" class="control" type="text" formControlName="memberId" />
            <span class="error-text" *ngIf="getError('memberId') as err">{{ err }}</span>
          </div>

          <div class="field">
            <label class="field-label" for="inGroup">Group Number</label>
            <input id="inGroup" class="control" type="text" formControlName="groupNumber" />
            <span class="error-text" *ngIf="getError('groupNumber') as err">{{ err }}</span>
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <label class="field-label" for="inStart">Start Date</label>
            <div class="date-wrap">
              <input id="inStart" class="control date-control" [matDatepicker]="startPicker" formControlName="startDate"
                readonly placeholder="Select date" (click)="startPicker.open()" />
              <mat-datepicker-toggle class="date-toggle" [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </div>
          </div>

          <div class="field">
            <label class="field-label" for="inEnd">End Date</label>
            <div class="date-wrap">
              <input id="inEnd" class="control date-control" [matDatepicker]="endPicker" formControlName="endDate"
                [min]="endMin" readonly placeholder="Select date" (click)="endPicker.open()" />
              <mat-datepicker-toggle class="date-toggle" [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </div>
            <span class="error-text" *ngIf="getError('endDate') as err">{{ err }}</span>
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <label class="field-label" for="inPlan">Plan Name <span class="req">*</span></label>
            <input id="inPlan" class="control" type="text" formControlName="planName" />
            <span class="error-text" *ngIf="getError('planName') as err">{{ err }}</span>
          </div>

          <div class="field">
            <label class="field-label" for="inStatus">Status <span class="req">*</span></label>
            <select id="inStatus" class="control select" formControlName="status"
              [compareWith]="sameValue" [class.is-placeholder]="!myForm.get('status')?.value">
              <option [ngValue]="''" disabled>Select status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
            <span class="error-text" *ngIf="getError('status') as err">{{ err }}</span>
          </div>
        </div>

        <div class="form-row form-row--full">
          <div class="field">
            <label class="field-label" for="inComment">Add More Details (Optional)</label>
            <textarea id="inComment" class="control textarea" rows="2" formControlName="comment"></textarea>
            <span class="error-text" *ngIf="getError('comment') as err">{{ err }}</span>
          </div>
        </div>
      </ng-container>

      <!-- ========== IMMUNIZATION ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'immunization'">
        <div class="form-row">
          <div class="field">
            <label class="field-label" for="imVaccine">Vaccine Name <span class="req">*</span></label>
            <select id="imVaccine" class="control select" formControlName="vaccineName"
              [compareWith]="sameValue" [class.is-placeholder]="!myForm.get('vaccineName')?.value">
              <option [ngValue]="''" disabled>Select vaccine</option>
              <option *ngFor="let vaccine of immunization" [ngValue]="vaccine.title">{{ vaccine.title }}</option>
              <option [ngValue]="'Others'">Others</option>
            </select>
            <span class="error-text" *ngIf="getError('vaccineName') as err">{{ err }}</span>
            <div class="other-wrap" *ngIf="hasOther('vaccineName')">
              <input id="vaccineOther" class="control other-input" type="text" formControlName="vaccineOther"
                placeholder="Specify vaccine name" aria-label="Other vaccine name" />
              <span class="error-text" *ngIf="getError('vaccineOther') as err">{{ err }}</span>
            </div>
          </div>

          <div class="field">
            <label class="field-label" for="imAdmin">Administered Date <span class="req">*</span></label>
            <div class="date-wrap">
              <input id="imAdmin" class="control date-control" [matDatepicker]="adminPicker" formControlName="adminDate"
                [max]="today" readonly placeholder="Select date" (click)="adminPicker.open()" />
              <mat-datepicker-toggle class="date-toggle" [for]="adminPicker"></mat-datepicker-toggle>
              <mat-datepicker #adminPicker></mat-datepicker>
            </div>
            <span class="error-text" *ngIf="getError('adminDate') as err">{{ err }}</span>
          </div>
        </div>

        <div class="form-row form-row--full">
          <div class="field">
            <label class="field-label" for="imNext">Next Due Date</label>
            <div class="date-wrap">
              <input id="imNext" class="control date-control" [matDatepicker]="nextPicker" formControlName="nextDueDate"
                [min]="nextDueMin" readonly placeholder="Select date" (click)="nextPicker.open()" />
              <mat-datepicker-toggle class="date-toggle" [for]="nextPicker"></mat-datepicker-toggle>
              <mat-datepicker #nextPicker></mat-datepicker>
            </div>
            <span class="error-text" *ngIf="getError('nextDueDate') as err">{{ err }}</span>
          </div>
        </div>

        <div class="form-row form-row--full">
          <div class="field">
            <label class="field-label" for="imDetail">Add More Details (Optional)</label>
            <textarea id="imDetail" class="control textarea" rows="2" formControlName="detail"></textarea>
          </div>
        </div>
      </ng-container>

    </form>
  </div>

  <!-- Action buttons (fixed) -->
  <div class="dialog-actions" *ngIf="dialogMode !== 'view'">
    <button type="button" class="btn btn-outline" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
  </div>

  <!-- View Details actions -->
  <div class="dialog-actions" *ngIf="dialogMode === 'view'">
    <button type="button" class="btn btn-outline" (click)="onCancel()">Close</button>
    <button type="button" class="btn btn-primary" (click)="onEditFromView()">Edit</button>
  </div>
</div>

<!-- Insurance document preview ("view document" dialog). Rendered through the CDK overlay (see previewInsuranceDoc in the .ts)
     so it opens above the Add/Edit Insurance dialog. -->
<ng-template #insPreviewTpl>
  <div class="ins-preview" role="dialog" aria-modal="true" aria-labelledby="ins-preview-title">
    <div class="ins-preview-header">
      <h2 id="ins-preview-title" class="ins-preview-title">{{ insPreview?.name }}</h2>
      <button type="button" class="ins-preview-close" aria-label="Close preview" (click)="closeInsurancePreview()">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
    <div class="ins-preview-body" *ngIf="insPreview as p">
      <div *ngIf="p.loading" class="ins-preview-loading">
        <span class="ins-preview-spinner" aria-hidden="true"></span>
        <p>Loading document preview...</p>
      </div>
      <ng-container *ngIf="!p.loading">
      <iframe *ngIf="p.kind === 'pdf'" class="ins-preview-frame" [src]="p.safeUrl" [title]="p.name"></iframe>
      <img *ngIf="p.kind === 'image'" class="ins-preview-image" [src]="p.url" [alt]="p.name" />
      <video *ngIf="p.kind === 'video'" class="ins-preview-media" controls [src]="p.safeUrl" (error)="markInsurancePreviewUnsupported()"></video>
      <div *ngIf="p.kind === 'audio'" class="ins-preview-none">
        <mat-icon aria-hidden="true">audiotrack</mat-icon>
        <audio controls [src]="p.safeUrl" (error)="markInsurancePreviewUnsupported()"></audio>
      </div>

      <!-- text-based files (csv/tsv as a table, rtf/txt/json/xml... as text), read from the picked file in the browser -->
      <ng-container>
        <div *ngIf="p.kind === 'csv'" class="ins-preview-table-wrap">
          <table class="ins-preview-table">
            <thead *ngIf="p.head"><tr><th *ngFor="let c of p.head">{{ c }}</th></tr></thead>
            <tbody><tr *ngFor="let row of p.body"><td *ngFor="let c of row">{{ c }}</td></tr></tbody>
          </table>
        </div>
        <pre *ngIf="p.kind === 'text'" class="ins-preview-text">{{ p.text }}</pre>
        <p *ngIf="p.truncated" class="ins-preview-note">Only the first part of this file is shown.</p>
      </ng-container>

      <div *ngIf="p.kind === 'other'" class="ins-preview-none">
        <img class="ins-preview-none-icon" src="assets/images/docs.png" alt="document icon">
        <p>Preview not available for this file type</p>
        <p *ngIf="p.note" class="ins-preview-note">{{ p.note }}</p>
        <a *ngIf="p.url" class="ins-preview-download" [href]="p.safeUrl" [attr.download]="p.name">Download file</a>
      </div>
      </ng-container>
    </div>
  </div>
</ng-template>